module.exports = "/_next/static/public/images/metamask-514f1650103812f211d9a4102199515f.svg";